import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_FULL, APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_FULL.AI)({
    component: RouteComponent,
    staticData: {
        config: {
            breadcrumb: { title: "ai", to: APP_ROUTES_TO.AI_DIMENSION_DEFINITIONS },
            title: "ai",
        },
        permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
    },
});

function RouteComponent() {
    return <Outlet />;
}
